import React, { FunctionComponent } from 'react';
import DOMPurify from 'dompurify';
import styles from './BulletedList.module.scss';

interface IProps {
  items: string[];
}

const BulletedList: FunctionComponent<IProps> = ({ items }) => (
  <div>
    <ul className={styles.ul}>
      {items.map((item, index) => (
        <li key={`list-item-${index}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }} />
      ))}
    </ul>
  </div>
);

export default BulletedList;
